import { render, staticRenderFns } from "./GroupRedactor.vue?vue&type=template&id=3981af66&scoped=true&"
import script from "./GroupRedactor.vue?vue&type=script&lang=js&"
export * from "./GroupRedactor.vue?vue&type=script&lang=js&"
import style0 from "./GroupRedactor.vue?vue&type=style&index=0&id=3981af66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3981af66",
  null
  
)

export default component.exports